import { useEffect, useState } from "react";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import { Get_Count_Of_SEF_Status } from "../../api/Get_Count_Of_SEF_Status";
import { Get_Count_Of_SEF_Colors } from "../../api/Get_Count_Of_SEF_Colors";

function Tally() {
  const { logout } = StaffuseAuth();

  const [getIncompletewSEF, setgetIncompletewSEF] = useState([]);
  const [getIn_ProgresswSEF, setgetIn_ProgresswSEF] = useState([]);
  const [getAwaiting_ReviewSEF, setgetAwaiting_ReviewSEF] = useState([]);
  const [getUnderReviewSEF, setgetUnderReviewSEF] = useState([]);
  const [getCompleteSEF, setgetCompleteSEF] = useState([]);
  const [getColorsSEF, setgetColorsSEF] = useState([]);

  useEffect(() => {
    Get_Count_Of_SEF_Status(setgetCompleteSEF, "Complete", logout);
    Get_Count_Of_SEF_Status(
      setgetAwaiting_ReviewSEF,
      "Awaiting_Review",
      logout
    );
    Get_Count_Of_SEF_Status(setgetIn_ProgresswSEF, "In_Progress", logout);
    Get_Count_Of_SEF_Status(setgetIncompletewSEF, "Incomplete", logout);
    Get_Count_Of_SEF_Colors(setgetColorsSEF, logout);
    Get_Count_Of_SEF_Status(setgetUnderReviewSEF, "UnderReview", logout);
  }, []);
  console.log("getUnderReviewSEF");
  console.log(getUnderReviewSEF);

  //create a fucntion to get the count given the colour
  function getCountFromColor(color) {
    let result = getColorsSEF.filter((One) => One._id === color);
    if (result.length === 0) {
      return { count: 0 };
    } else {
      return result[0];
    }
  }
  //now create a function to sum all values of count
  function sumAllColorCount() {
    let sum = 0;
    getColorsSEF.forEach((One) => {
      sum += One.count;
    });
    return sum;
  }

  const arr_allDates = ["7th July", "28th July", "18th Aug"];

  //Sum all the "Count" or every object in an array
  function sumAllCountsInArray(Arr) {
    return Arr.reduce((accumulator, current) => {
      return accumulator + (current.Count || 0);
    }, 0);
  }

  //Get teh Count from the Object with a Specific Date
  function getCountFromDate(date, Arr) {
    let result = Arr.filter((obj) => obj._id === date);
    if (result.length === 0) {
      return 0;
    } else {
      return result[0].Count || 0;
    }
  }

  return (
    <div style={{ marginLeft: "10px", display: "flex" }}>
      <div style={{ marginRight: "10px" }}>
        <h1>Progress</h1>
        <h4>
          Incomplete: {sumAllCountsInArray(getIncompletewSEF)}
          <br></br>
          In Progress: {sumAllCountsInArray(getIn_ProgresswSEF)}
          <br></br>
          Awaiting Review: {sumAllCountsInArray(getAwaiting_ReviewSEF)}
          <br></br>
          <i>
            Unnasigned, Awaiting Review:{" "}
            {sumAllCountsInArray(getAwaiting_ReviewSEF) -
              sumAllCountsInArray(getUnderReviewSEF)}
            <br></br>
            Assigned, Under Review: {sumAllCountsInArray(getUnderReviewSEF)}
          </i>
          <br></br>
          Complete: {sumAllCountsInArray(getCompleteSEF)}
        </h4>
      </div>
      {arr_allDates.map((chosenDate) => (
        <div style={{ marginRight: "10px" }}>
          <h1>{chosenDate}</h1>
          <h4>
            Incomplete: {getCountFromDate(chosenDate, getIncompletewSEF)}
            <br></br>
            In Progress: {getCountFromDate(chosenDate, getIn_ProgresswSEF)}
            <br></br>
            Awaiting Review:{" "}
            {getCountFromDate(chosenDate, getAwaiting_ReviewSEF)}
            <br></br>
            <i>
              Unnasigned, Awaiting Review:{" "}
              {getCountFromDate(chosenDate, getAwaiting_ReviewSEF) -
                getCountFromDate(chosenDate, getUnderReviewSEF)}
              <br></br>
              Assigned, Under Review:{" "}
              {getCountFromDate(chosenDate, getUnderReviewSEF)}
            </i>
            <br></br>
            Complete: {getCountFromDate(chosenDate, getCompleteSEF)}
          </h4>
        </div>
      ))}
      <div>
        <h1>Colors</h1>
        <h4>
          Red: {getCountFromColor("Red").count || 0}
          <br></br>
          Amber: {getCountFromColor("Amber").count || 0}
          <br></br>
          Green: {getCountFromColor("Green").count || 0}
          <br></br>
          Blue: {getCountFromColor("Blue").count || 0}
          <br></br>
          Grey:{" "}
          {sumAllCountsInArray(getAwaiting_ReviewSEF) +
            sumAllCountsInArray(getCompleteSEF) -
            sumAllColorCount()}
        </h4>
      </div>
    </div>
  );
}

export default Tally;
